import { DEVELOPERS } from '../constants'

export function useAboutDevelopersList() {
    return { developers: DEVELOPERS }
}
